import { mapState } from 'vuex';
import f from "@/application/shared/functions.js";

import storyPreview from "@/components/modules/stories/preview/index.vue";
import story from "@/components/modules/stories/story/index.vue";
import intro from "@/components/modules/chats/chat/intro/index.vue";
import support from "@/components/modules/chats/chat/support/index.vue";
import last from "@/components/modules/chats/chat/last/index.vue";



export default {
    name: 'chatevent',
    props: {
        event : Object,
        height : Number,
        parentview : String,
        focused : Boolean,
        room : String
        
    },

    data : function(){

        return {
            loading : false,
            wasfocused : false,
            wasviewed : false,
            initedStory : false
        }

    },

    components : {
        storyPreview,
        story,
        intro,
        last,
        support
    },

    created(){
    },

    watch: {
        focused : {
            immediate : true,
            handler : function(){
                if(this.focused){
                    this.wasviewed = true
                    setTimeout(() => {
                        if (this.focused){
                            this.wasfocused = true
                        }
                    }, 300)

                    if (this.event.data.type == 'message' && this.parentview == 'storyview' && this.$refs.message){
                        this.$refs.message.scrollTop = 0
                    }
                }

                else{
                    if (this.$refs['story'] && this.$refs['story'].pause){
                        setTimeout(() => {
                            if(!this.$refs['story'].silencemodeEnabled())
                                this.$refs['story'].pause()
                        }, 300)
                        
                    }
                }


            }
        }
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        vmessage : function(){

            if(this.event.type == 'message') {
                if(this.event.data.type == 'message' || this.event.data.type == 'system') {
                    return f.convertNewLinesToBr(f.superXSS(this.event.data.text))
                }
            }

            return ''
        },

        you : function(state){

            var me = this.core.user.info.userinfo.id

            return this.event.creator == me
        },
        autoplaywk : function(){
            return true
            return window.cordova ? true : false
        } 
    }),

    methods : {
        click : function(){
            this.$emit('click', this.event)
        },

        copymessage : function(){
            f.copyTextToClipboard(this.event.data.message)

            this.core.sitemessage(this.$t('labels.copied'))
        },

        copycode : function(){
            f.copyTextToClipboard(f.convertNewLinesToBr(this.event.data.html))

            this.core.sitemessage(this.$t('labels.copied'))

        },

        gotostory : function(){


            if(!this.core.user.checkFeatures(['news'])) return

            if (this.parentview == 'storyview'){
                this.initedStory = true
            }
            else{
                this.$router.push('stories/' + this.event.data.story)
            }

            
        },

        storymoderation : function(){


            if(!this.core.user.checkFeatures(['moderation'])) return

            this.core.vueapi.taskdata({
				uid : this.event.data.task
			}, {
				changed : () => {
					this.$emit('changed')
				}
			})
            
        },

        clickMetaButton : function(){
            if (this.event.data.button.url){
                this.$router.push(this.event.data.button.url)
                return
            }
        },

        touchhold : function(){
            if(this.event.data.type == 'meta'){
                var menu = [
                    {
                        text: 'button.removemessage',
                        icon: 'fas fa-trash',
                        action : this.removemessage
                    }
                ]

                this.core.vueapi.listmenupromise(menu).catch(e => {})
            }
        },

        removemessage : function(){
            this.core.chats.api.remove(this.room, [this.event.id]).then(() => {
            })
        },

        end : function(){
            this.$emit('finishStory')
        }
    },
}